export const SAVE_DEFAULT_CARRIERS_SUCCESS = 'SAVE_DEFAULT_CARRIERS_SUCCESS';
export const SAVE_DEFAULT_CARRIERS_REQUEST = 'SAVE_DEFAULT_CARRIERS_REQUEST';
export const SAVE_DEFAULT_CARRIERS_FAILURE = 'SAVE_DEFAULT_CARRIERS_FAILURE';
export const SAVE_DEFAULT_CARRIERS_REST = 'SAVE_DEFAULT_CARRIERS_REST';
export const saveDefaultCarriersSuccess = (payload) => ({
    type: SAVE_DEFAULT_CARRIERS_SUCCESS,
    payload,
});
export const saveDefaultCarriersRequest = (payload) => ({
    type: SAVE_DEFAULT_CARRIERS_REQUEST,
    payload,
});
export const saveDefaultCarriersFailure = (payload) => ({
    type: SAVE_DEFAULT_CARRIERS_FAILURE,
    payload,
});
export const saveDefaultCarriersRest = () => ({
    type: SAVE_DEFAULT_CARRIERS_REST,
});
